
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'CombinationsStepInfo',
})
export default class CombinationsStepInfo extends Vue {
    @Prop({ type: String, default: '' }) private description!: string;
    @Prop({ type: String, default: 'normal' }) private variant!: 'normal' | 'warning';

    private get formattedDescription(): string {
        // Replace newlines with <br> tags to create line breaks
        return this.description.replace(/\n/g, '<br>');
    }
}
